import {
  getPulseForDeviceType,
  getReadingTimeString,
  getReadingValueForDeviceType,
} from "@/utils/readingsHelpers";

export const getCurrentUserId = (state) => {
  return state.currentUser;
};

export const getCurrentUserProfile = (state) => {
  return state.currentUserProfile;
};

export const getCurrentUsersDevices = (state) => {
  return state.currentUsersDevices;
};

export const getEnvConfig = (state) => {
  return state.envConfig;
};

export const getRelationships = (state) => {
  return state.relationships;
};

export const getSpecialties = (state) => {
  return state.specialties;
};

export const getShareHistory = (state) => {
  return state.shareHistory;
};

export const postShareHistory = (state) => {
  return state.postShareHistory;
};

export const getLatestReadingsForDevice = (state) => {
  return state.latestReadingsForDevice;
};

export const createLatestReading = (deviceType) => (state) => {
  if (state[`readingsFor${deviceType}`]) {
    const readings = {};
    const reading = state[`readingsFor${deviceType}`];
    readings["timeText"] = getReadingTimeString(reading);
    readings["readingValue"] = getReadingValueForDeviceType(
      deviceType,
      reading
    );
    readings["pulse"] = getPulseForDeviceType(deviceType, reading);
    return readings;
  }
  return null;
};
export const latestGlucometerReading = createLatestReading("GLUCOMETER");
export const latestScaleReading = createLatestReading("SCALE");
export const latestBloodPressureReading = createLatestReading("BP_CUFF");
export const latestThermometerReading = createLatestReading("THERMOMETER");
export const latestPulseOximeterReading = createLatestReading("PULSE_OXIMETER");

export const checkIfUserHasDevice = (state) => {
  const devices = {
    BP_CUFF: latestBloodPressureReading(state),
    THERMOMETER: latestThermometerReading(state),
    PULSE_OXIMETER: latestPulseOximeterReading(state),
    SCALE: latestScaleReading(state),
    GLUCOMETER: latestGlucometerReading(state),
  };
  const dev = new Set(
    state.currentUsersDevices.map((device) => device.device_type.category)
  );
  for (const key of Object.keys(devices)) {
    if (!dev.has(key)) {
      delete devices[key];
    }
  }
  return devices;
};
export const guessCount = (state) => {
  return state.guesses.filter((guess) => guess !== "").length;
};

export const allWordGameWords = (state) => {
  const wordOfTheDay = state.allWordGameWords.map((word) => {
    return word.word_of_the_day;
  }, []);
  return wordOfTheDay;
};
